import { CdkOverlayOrigin, OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
  Component, OnDestroy, OnInit, ViewChild, inject, signal,
} from '@angular/core';
import {
  ActivatedRoute, NavigationEnd, Router, RouterModule,
} from '@angular/router';

import {
  AuthService,
  LanguageService,
  Language,
  PageService,
  User,
  capitalizeFirstLetter,
} from '@instaclause-webapp/shared-core';
import {
  ButtonAlertComponent,
  InitialsPipe,
  InlineSvgComponent,
  LogoComponent,
  TooltipDirective,
} from '@instaclause-webapp/shared-ui';
import { TranslocoModule } from '@jsverse/transloco';
import { filter, Subscription } from 'rxjs';

import { UserMenuComponent } from '../user-menu/user-menu.component';
interface Breadcrumb {
  icon: string;
  title: string;
  path: string;
}

@Component({
  selector: 'app-menu',
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    LogoComponent,
    InlineSvgComponent,
    ButtonAlertComponent,
    OverlayModule,
    TooltipDirective,
    UserMenuComponent,
    InitialsPipe,
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent implements OnInit, OnDestroy {
  @ViewChild(UserMenuComponent) userMenu!: UserMenuComponent;
  user!: User | null;
  availableLanguages!: Language[];
  alertsOpen = false;
  userMenuOpen = false;

  breadcrumb = signal<Breadcrumb[]>([]);

  protected pageService = inject(PageService);
  private subscription = new Subscription();
  private authService = inject(AuthService);
  private languageService = inject(LanguageService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.breadcrumb.set(this.getBreadcrumbs(this.activatedRoute));
    });
  }

  ngOnInit(): void {
    this.availableLanguages = this.languageService.getAvailableLanguages();
    this.subscription.add(this.authService.user$.subscribe((user) => (this.user = user)));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onChangeLanguage(language: Language): void {
    this.languageService.changeLanguage(language);
  }

  capitalizeLetter(value: string): string {
    return capitalizeFirstLetter(value);
  }

  triggerMenu(event: MouseEvent, trigger: CdkOverlayOrigin): void {
    this.userMenuOpen = !this.userMenuOpen;

    if (this.userMenuOpen) {
      event.stopPropagation();
      this.userMenu.openMenu(trigger);
    } else {
      this.userMenu.closeMenu();
    }
  }

  onCloseMenu() {
    this.userMenuOpen = false;
  }

  getBreadcrumbs(activatedRoute: ActivatedRoute): Breadcrumb[] {
    const breadcrumbs = [];

    if (activatedRoute.snapshot.data['breadcrumb']) {
      breadcrumbs.push(activatedRoute.snapshot?.data['breadcrumb']);
    }

    if (activatedRoute.firstChild) {
      return [ ...breadcrumbs, ...this.getBreadcrumbs(activatedRoute.firstChild) ];
    }

    return breadcrumbs || [];
  }
}
